<template>
  <div
    :class="['share',theme]"
    v-clipboard:copy="shareLink"
    v-clipboard:success="onShareCopy"
    v-clipboard:error="onError"
  >
    <slot>
      <svg class="icon iconfont">
        <use :href="icon" />
      </svg>
      <span>分享</span>
    </slot>

    <div :class="['msg',message?'showmsg':'']" ref="msg">{{message}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: ""
    };
  },
  props: ["sharedata", "icon", "shareLink", "theme"],

  methods: {
    //分享
    onShareCopy(e) {
      if (this.theme == "mobile") {
        if (this.yach.platform != "notInYach" && this.yach.share) {
          console.log("yach share data---", this.sharedata);
          this.yach.share({
            type: 0,
            url: location.href,
            title: this.sharedata.title || "视频分享",
            content: this.sharedata.content,
            image: this.sharedata.img
          });
        } else if (navigator.share) {
          navigator.share({
            title: "视频分享",
            text: this.sharedata.title || "视频分享",
            url: e.text
          });
        } else {
          this.message = "链接已复制成功，快去分享吧～";
          setTimeout(() => {
            this.message = "";
          }, 2000);
        }
      } else {
        this.message = "链接已复制成功，快去分享吧～";
        setTimeout(() => {
          this.message = "";
        }, 2000);
      }
    },
    onError(e) {
      this.message = "复制失败";
      setTimeout(() => {
        this.message = "";
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
.share {
  // display: flex;
  // align-items: center;
  padding: 0.02rem;
  text-align: center;
  span {
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #fff;
  }
  .iconfont {
    margin-right: 0.06rem;
    width: 0.2rem;
    height: 0.2rem;
  }
  &.web {
    .iconfont {
      margin-right: 4px;
      width: 32px;
      height: 32px;
    }
  }
}
.share.mobile {
  .msg {
    position: fixed;
    bottom: 0.48rem;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 6px;
    // width: 1.22rem;
    // height: 0.4rem;
    line-height: 0.4rem;
    background: #333333;
    border-radius: 6px;
    opacity: 0.8;
    font-size: 0.16rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    z-index: 1;
    white-space: nowrap;
    display: none;
    &.showmsg {
      display: block;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/catalogueShare/components/share.vue